import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { useTableGridContext } from './TableGrid.context';
import { noResultsStyle, tableCellStyle, tableRowStyle } from './TableRow.css';

export const TableRowNoResults = () => {
  const { isLoading } = useTableGridContext();

  const { t } = useTranslation(['common']);

  return (
    <div className={tableRowStyle}>
      <div className={clsx(tableCellStyle, noResultsStyle)}>
        {isLoading ? t('common:datatable.loadingData') : t('common:datatable.noData')}
      </div>
    </div>
  );
};
